import { DateTime } from 'luxon';
import { CouponType } from './CouponType';

export interface Coupon {
  id: number;
  code: string;
  name: string;
  type: CouponType;
  value: number;
  minimumSpend: number;
  maximumDiscount?: number;
  usageLimitPerCoupon?: number;
  usageLimitPerCustomer?: number;
  startAt: Date;
  endAt: Date;
  isActive: boolean;
  specificForUser: boolean;
  specificForCategory: boolean;
  specificForProduct: boolean;
  userEmails: string[];
  categoryIDs: number[];
  productIDs: number[];
}

export const getEmptyCoupon = (): Coupon => ({
  id: 0,
  code: '',
  name: '',
  type: CouponType.FIXED,
  value: 0,
  minimumSpend: 0,
  startAt: new Date(),
  endAt: DateTime.now().plus({ day: 1 }).toJSDate(),
  isActive: false,
  specificForUser: false,
  specificForCategory: false,
  specificForProduct: false,
  userEmails: [],
  categoryIDs: [],
  productIDs: [],
});

export const couponFromResponse = (responseData: any): Coupon => ({
  id: responseData.id,
  code: responseData.code,
  name: responseData.name,
  type: responseData.type,
  value: responseData.value,
  minimumSpend: responseData.minimum_spend,
  maximumDiscount: responseData.maximum_discount,
  usageLimitPerCoupon: responseData.usage_limit_per_coupon,
  usageLimitPerCustomer: responseData.usage_limit_per_customer,
  startAt: new Date(responseData.start_at),
  endAt: new Date(responseData.end_at),
  isActive: responseData.is_active,
  specificForUser: responseData.specific_for_user,
  specificForCategory: responseData.specific_for_category,
  specificForProduct: responseData.specific_for_product,
  userEmails: responseData.user_emails ?? [],
  categoryIDs: responseData.category_ids ?? [],
  productIDs: responseData.product_ids ?? [],
});

export const couponToUpsertRequest = (coupon: Coupon) => ({
  code: coupon.code,
  name: coupon.name,
  type: coupon.type,
  value: coupon.value,
  minimum_spend: coupon.minimumSpend,
  maximum_discount: coupon.maximumDiscount,
  usage_limit_per_coupon: coupon.usageLimitPerCoupon,
  usage_limit_per_customer: coupon.usageLimitPerCustomer,
  start_at: DateTime.fromJSDate(coupon.startAt).toISO(),
  end_at: DateTime.fromJSDate(coupon.endAt).toISO(),
  is_active: coupon.isActive,
  specific_for_user: coupon.specificForUser,
  specific_for_category: coupon.specificForCategory,
  specific_for_product: coupon.specificForProduct,
  user_emails: coupon.userEmails,
  category_ids: coupon.categoryIDs,
  product_ids: coupon.productIDs,
});
